export const FETCH_SHIPMENT_LIST_SUCCESS = "FETCH_SHIPMENT_LIST_SUCCESS";
export const FETCH_SHIPMENT_LIST_REQUEST = "FETCH_SHIPMENT_LIST_REQUEST";
export const FETCH_SHIPMENT_LIST_FAILURE = "FETCH_SHIPMENT_LIST_FAILURE";
export const FETCH_SHIPMENT_LIST_REST = "FETCH_SHIPMENT_LIST_REST";
export const fetchShipmentListSuccess = (payload) => ({
    type: FETCH_SHIPMENT_LIST_SUCCESS,
    payload,
});
export const fetchShipmentListRequest = (payload) => ({
    type: FETCH_SHIPMENT_LIST_REQUEST,
    payload,
});
export const fetchShipmentListFailure = (payload) => ({
    type: FETCH_SHIPMENT_LIST_FAILURE,
    payload,
});
export const fetchShipmentListRest = () => ({
    type: FETCH_SHIPMENT_LIST_REST,
});
